'use client';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import './index.scss';
import IndexClient from './index.client';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, list, bgColor = 'black', activeIndex = 0 } = data;
    const prefixCls = 'index-user-story-1';

    console.log('data', data);
    return (
        <GloLayout
            className={`editor-${prefixCls} editor-${prefixCls}-${id}`}
            id={id}
            data={data}
            floorName={`${prefixCls}`}
            style={{ backgroundColor: bgColor }}
        >
            <div className={`${prefixCls}-wrapper`}>
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <div className={`${prefixCls}-box`}>
                    <IndexClient list={list} prefixCls={prefixCls} id={id} activeIndex={activeIndex} />
                </div>
            </div>
        </GloLayout>
    );
}
